import { Link } from "react-router-dom"
import PlaceBadge from "./PlaceBadge"

import { colorCode, safetyPercentage } from "../utilities/helpers"
import { RISK_CATEGORIES } from "../const/riskCategories"

export default function CardSummary({
    place,
    currentLocation,
    mainCard = false,
    mode = "full",
}) {
    return (
        <div className="d-flex">
            {mode === "mini" && (
                <div className="me-3">
                    <PlaceBadge place={place} mode={mode} />
                </div>
            )}

            <div className="card-body flex-grow-1">
                <h5 className="card-title pb-2">
                    {place?.fromGoogle?.name
                        ? place?.fromGoogle?.name
                        : `${place?.name} (${place?.country})`}
                </h5>

                {RISK_CATEGORIES.map(({ key, icon, label }) => {
                    const score = place?.[key]
                    // A missing score renders grey ("no data"), not red:
                    // colorCode() treats NaN as the lowest band.
                    const hasScore = score != null && score !== ""
                    const percent = hasScore ? safetyPercentage(score) : null
                    return (
                        <i
                            key={key}
                            className={`bi ${icon} pe-2 text-${
                                hasScore ? colorCode(percent) : "secondary"
                            }`}
                            title={`${label}: ${hasScore ? `${percent}%` : "no data"}`}
                        ></i>
                    )
                })}

                {/* Personal Safety: not scored yet, same as the Analysis page. */}
                <i
                    className="bi bi-person-bounding-box pe-2 text-secondary"
                    title="Personal Safety: no data"
                ></i>

                <p className="card-text text-start pt-3">
                    {place.overall_safety_overview}
                </p>
                <Link to={`/analysis/${place?.slug}`}>
                    <button
                        className={`btn ${
                            mainCard
                                ? "btn-lg btn-danger"
                                : "btn-outline-secondary"
                        } mt-3 mb-3`}
                    >
                        {" "}
                        Analysis{" "}
                    </button>
                </Link>
            </div>
        </div>
    )
}
